import {CustomerInvoiceTable} from "../CustomerInvoiceTable";

export const RecentInvoices = ({ customerId }: { customerId: string; }) => (
  <div className="gap-[28px] mt-[24px] md:mt-[1em] ">
    <h3 className="text-[20px] mt-[] font-semibold 540:ml-[3em] lg:ml-0 md:ml-0">Recent Invoices</h3>
    <div className="flex justify-center items-center  mt-[-3em] md:mt-[-1em] xl:mt-[-1em] biglg:mt-[-1em] 540:mt-[1em] ">
      <CustomerInvoiceTable customerId={customerId} />
    </div>
    
  </div>
);